import { render, staticRenderFns } from "./channelSkuMedia.vue?vue&type=template&id=1c4223f3&"
import script from "./channelSkuMedia.vue?vue&type=script&lang=ts&"
export * from "./channelSkuMedia.vue?vue&type=script&lang=ts&"
import style0 from "./channelSkuMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports